<div class="toolbar">
  <div class="toolbar__logo">
    <a
      href="/"
      [title]="environment.name"
    >
      <img
        src="/assets/base/img/logo.svg"
        [alt]="environment.name"
        class="zp-logo__img"
      />
    </a>
    <zp-toolbar-report-backend />
  </div>

  <div class="toolbar__navigation">
    <div class="hidden md:flex ml-5">
      <p-tabs value="/dashboard">
        <p-tablist class="toolbar-menu">
          @for (tab of tabs; track tab.route) {
            <p-tab
              [value]="tab.route"
              [routerLink]="tab.route"
              class="flex items-center !gap-2 text-inherit"
            >
              <span>{{ tab.name }}</span>
            </p-tab>
          }
        </p-tablist>
      </p-tabs>
    </div>
  </div>

  @if (user) {
    <div class="toolbar__actions">
      <div class="flex">

        @if (isAmAssigned) {
          <button
            (click)="contactInfoPopover.toggle($event)"
            class="toolbar__round-button rounded-full hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-[var(--p-primary-300)]"
          >
              <cw-icon svgId="envelope" class="primary-color" />
          </button>

          <p-popover #contactInfoPopover>
            <zp-toolbar-contact-info />
          </p-popover>
        }

      </div>

      <div>
        <button
          class="cursor-pointer rounded-full focus:outline-none focus:ring-2 focus:ring-[var(--p-primary-300)] hover:bg-gray-100"
          (click)="userMenuPopover.toggle($event)"
        >
          <p-avatar
            [label]="userFirstLetter"
            size="normal"
            shape="circle"
          />
        </button>

        <p-popover
          #userMenuPopover
          appendTo="body"
        >
          <zp-toolbar-user-menu />
        </p-popover>
      </div>
    </div>
  }

</div>

<zp-toolbar-dock class="md:hidden" [items]="dockItems" />


